import { Box, Header, Table } from '@amzn/awsui-components-react-v3';
import { Button } from 'AWS-UI-Components-React';
import React from 'react';
import '../../../styles/spotcp.css';
import { downloadFile, toDownloadFormat } from '../../../utilities';
import { EmptyMessage } from '../../content/empty_message';
import { OPERATION_STATUS } from '../common/constants';
import { BoldEntries } from './flcp_utils';

const columnDefinitions = [
  {
    id: "component",
    header: "Component",
    cell: e => {
      const fontWeight = BoldEntries.includes(e.component ) ? 'bold' : 'normal';
      return (
        <Box textAlign="left" fontWeight={fontWeight}>
          {e.component}
        </Box>
      );
    }
  },
  {
    id: "absVariancePerUnit",
    header: "Abs Variance Per Unit",
    cell: (e) => {
      const fontWeight = BoldEntries.includes(e.component ) ? 'bold' : 'normal';
      return (
        <Box textAlign="left" fontWeight={fontWeight}>
          {Math.round(e.absVariancePerUnit * 10000) / 10000 || '-'}
        </Box>);
    },
  }
];
const title = "FLCP Accuracy Summary";
const description = "FLCP Abs Variance Per Unit by Component";

export class FLCPSAccuracySummaryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadStatus: OPERATION_STATUS.NONE,
    };
  };

  onDownloadData = () => {
    this.setState({downloadStatus: OPERATION_STATUS.IN_PROGRESS});
    const data = toDownloadFormat(columnDefinitions, this.props.items);
    downloadFile(data, `FLCP_Accuracy_Summary_${this.props.payload.timeFrame}.xls`);
    this.setState({downloadStatus: OPERATION_STATUS.SUCESS});
  }

  render() {
    const {items, loading} = this.props;
    const empty = !items || !items.length;

    return (
      <React.Fragment>
        <div className="awsui-util-action-stripe">
          <div className="awsui-util-action-stripe-title" />
          <div className="awsui-util-action-stripe-group">
            <Button
              text="Download"
              variant="normal"
              onClick={ this.onDownloadData }
              disabled={ loading || empty }
              loading={ this.state.downloadStatus === OPERATION_STATUS.IN_PROGRESS }
            />
          </div>
        </div>
        <br/>
        <Table
          className="ZebraStripesTable accuracy-table-container"
          columnDefinitions={ columnDefinitions }
          items={ items }
          loading={ loading }
          resizableColumns
          loadingText="Loading Data..."
          header={
            <Header variant="h2" description={ description }>
              { title }
            </Header>
          }
          empty={ <EmptyMessage /> }
        />
      </React.Fragment>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/reports/flcp/flcp_accuracy_summary_table.jsx